<!--Desktop Back Button-->
<div class="ps-0 d-back-button container d-none d-lg-block">
  <button class="back-btn d-flex align-items-center justify-content-center" (click)="goBack()" aria-label="Back">
    <span class="material-icons text-white">arrow_back_ios</span>
  </button>
</div>

<!--Lotto Details-->
<div class="position-relative">
  <!--Mobile Back Button - overlaid on image-->
  <button
    class="back-btn back-btn--overlay d-flex d-lg-none align-items-center justify-content-center position-absolute"
    (click)="goBack()"
    aria-label="Back"
  >
    <span class="material-icons text-white">arrow_back_ios</span>
  </button>
  <fgbcl-lotto-details-v2 [lottoId]="id" />
</div>
